var map = {
	"./air-nga-en/assets/user-icon.png": 80077,
	"./ais-tai-en/assets/user-icon.png": 76000,
	"./ais-tai-tha/assets/user-icon.png": 86852,
	"./demo-arabic/assets/user-icon.png": 62284,
	"./demo-et-en/assets/user-icon.png": 97657,
	"./demo-romanian/assets/user-icon.png": 24883,
	"./demo-um-en/assets/user-icon.png": 68524,
	"./dtac-tai-en/assets/user-icon.png": 98099,
	"./dtac-tai-tha/assets/user-icon.png": 40565,
	"./ethiotel-et-amh/assets/user-icon.png": 1399,
	"./ethiotel-et-en/assets/user-icon.png": 89070,
	"./mtn-cg-fr/assets/user-icon.png": 58671,
	"./mtn-ci-fr/assets/user-icon.png": 73957,
	"./mtn-cmr-fr/assets/user-icon.png": 97841,
	"./mtn-gha-en/assets/user-icon.png": 41926,
	"./mtn-nga-en/assets/user-icon.png": 45250,
	"./mtn-zam-en/assets/user-icon.png": 10412,
	"./saf-ke-en/assets/user-icon.png": 4289,
	"./saudi-uae-en/assets/user-icon.png": 11708,
	"./tlk-za-en/assets/user-icon.png": 32685,
	"./vc-za-en/assets/user-icon.png": 72689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64493;